import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBrokenHeart: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="broken-heart, delete-account"><path d="M12 15L13 12L10 8.99996C10.4876 7.78835 11.1207 6.53558 12 5.57193C18.3331 -0.86765 29.1898 11.0916 12 20.75C-4.9474 11.2278 5.36623 -0.530796 11.7295 5.31041" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconBrokenHeart;
